import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faGripVertical } from '@fortawesome/pro-solid-svg-icons';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';
import badgeClass from '../shared/document_badge';

export class DefaultPageRow extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    index: PropTypes.number.isRequired,
    page: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }),
    onRemovePage: PropTypes.func.isRequired
  }


  render() {
    const { page } = this.props;
    if (!page) return null;

    const { connectDragPreview, connectDropTarget, connectDragSource, isDragging, onRemovePage, index } = this.props;
    const style = {
      opacity: isDragging ? 0 : 1,
    };

    return (
      connectDragPreview(
        connectDropTarget(
          <li className="list-group-item">
            <Row className="row-eq-height" style={style}>
              <Col xs={5}>
                {connectDragSource(
                  <div className="d-inline cursor-move">
                    <FontAwesomeIcon className="mr-2" icon={faGripVertical} />
                  </div>
                )}
                <span>{page.name}</span>
              </Col>
              <Col xs={5}>
                {page.user_label && (
                  <Badge className={`document-badge ${badgeClass('user_label')} mr-3`}>{page.user_label}</Badge>
                )}
                {page.size && (
                  <Badge className={`document-badge ${badgeClass('size', page.size)} mr-3`}>{page.size}</Badge>
                )}
              </Col>
              <Col className="text-right" xs={2}>
                <FontAwesomeIcon
                  className="text-red clickable"
                  icon={faMinusCircle}
                  name="remove-page"
                  onClick={() => onRemovePage(index)}
                />
              </Col>
            </Row>
          </li>
        )
      )
    );
  }
}

export default reorderableListItem(DefaultPageRow, 'defaultPageRow', {
  beginDrag(props) {
    return {
      id: props.page.id,
      index: props.index
    };
  }
});
